import React from 'react';
import { Flex, Heading } from "@magnetic/core";
import { Text } from "@magnetic/text";

const SuccessScreen = () => {

  return (
    <Flex direction="vertical" gap="xs" className="device-auth-flex">
      <Flex direction="vertical">
        <Heading>Success!</Heading>
        <Text color="light">
          You are now logged in.
        </Text>
      </Flex>
    </Flex>
  );
};

export default SuccessScreen;